export const PUBLIC_URL = process.env.PUBLIC_URL || '';
